import { DEV_TOOLS_ACTION_TYPE } from '../actions';

const initialState = {
  httpRequestLogs: [],
  httpRequestLogsTotal: 0,
  obLogs: {
    selectedLogId: null,
  },
};

const devToolsReducer = function (state = initialState, { type, payload }) {
  switch (type) {
    case DEV_TOOLS_ACTION_TYPE.GET_HTTP_REQUEST_LOGS:
      return { ...state, httpRequestLogs: payload.logs, httpRequestLogsTotal: payload.total };

    case DEV_TOOLS_ACTION_TYPE.APPEND_HTTP_REQUEST_LOGS: {
      const existingIds = new Set(state.httpRequestLogs.map(log => log.id));
      const uniqueNewLogs = payload.logs.filter(log => !existingIds.has(log.id));

      return {
        ...state,
        httpRequestLogs: [...state.httpRequestLogs, ...uniqueNewLogs],
        httpRequestLogsTotal: payload.total,
      };
    }

    case DEV_TOOLS_ACTION_TYPE.SELECT_LOG:
      return {
        ...state,
        obLogs: { ...state.obLogs, selectedLogId: payload },
      };

    default:
      return state;
  }
};

export default devToolsReducer;
